import { __AnswerErrorCode, __ViewErrorCode } from './SLP.interface';
import store from 'redux/store';
import { toast } from 'react-toastify';

export const viewErrMessage = (e: __ViewErrorCode[]) => {
    const msg = store.getState().lang.SLP.errorCodes;
    const err: string[] = [];
    if (e.includes(__ViewErrorCode.invalid)) err.push(msg.invalid);
    if (e.includes(__ViewErrorCode.noPublish)) err.push(msg.noPublish);
    if (e.includes(__ViewErrorCode.brokenPublish)) err.push(msg.brokenPublish);
    if (e.includes(__ViewErrorCode.disableForm)) err.push(msg.disableForm);
    if (e.includes(__ViewErrorCode.invalidParameter)) err.push(msg.invalidParameter);
    if (e.includes(__ViewErrorCode.invalidSource)) err.push(msg.invalidSource);
    if (e.includes(__ViewErrorCode.sourceUnique)) err.push(msg.sourceUnique);
    if (e.includes(__ViewErrorCode.parameterUnique)) err.push(msg.parameterUnique);
    if (e.includes(__ViewErrorCode.parameterDatalistUnidque)) err.push(msg.parameterDatalistUnique);
    return err;
};

export const answerErrToast = (e: __AnswerErrorCode[]) => {
    const msg = store.getState().lang.SLP.errorCodes;
    if (e.includes(__AnswerErrorCode.passwordRequired)) toast.error(msg.passwordRequired);
    if (e.includes(__AnswerErrorCode.invalidPassword)) toast.error(msg.invalidPassword);
};
